import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { OnboardingLevel } from 'store/entities/identity/records'
import ImmutablePropTypes from 'react-immutable-proptypes'

import ViewExamplesPopup from './ViewExamplesPopup/index'
import Button from 'app/components/ButtonDefault/index'
import AvailableDomain from 'app/components/SVGS/AvailableDomain'

import './styles.scss'

const baseClass = 'onboarding-protrack-level'

const ProtrackLevel = ({
  t,
  selectedProTrackLevelId,
  protrackLevel,
  selectText,
  submitting,
  onViewExamples,
  subscribeToProTrack,
  isFinished,
  svgProps,
}) => (
  <div className={baseClass}>
    <div className={`${baseClass}__image-wrapper`} style={{ backgroundColor: protrackLevel.get('color') }}>
      <img src={protrackLevel.get('image')} alt={protrackLevel.get('name')} className={`${baseClass}__image`} />
    </div>
    <div className={`${baseClass}__info`}>
      <div className={`${baseClass}__title`}>
        <span>{`${protrackLevel.get('proTrackName')} (${protrackLevel.get('name')})`}</span>
        {isFinished && (
          <Fragment>
            <span className={`${baseClass}__status`}>{t('Completed')}</span>
            <AvailableDomain {...svgProps} />
          </Fragment>
        )}
      </div>
      <div className={`${baseClass}__text`}>{protrackLevel.get('welcomeText')}</div>
    </div>
    <div className={`${baseClass}__buttons`}>
      {!!protrackLevel.get('exampleActivities').length && (
        <Button
          float
          onClick={() => onViewExamples(ViewExamplesPopup, { size: 'md', protrackLevel })}
          className={`${baseClass}__button`}
        >
          {t('View Examples')}
        </Button>
      )}
      <Button
        primary={!isFinished}
        onClick={() => subscribeToProTrack({ proTrackLevelId: protrackLevel.get('id') })}
        className={`${baseClass}__button`}
        disabled={submitting}
        submitting={submitting && protrackLevel.get('id') === selectedProTrackLevelId}
        outline={isFinished}
      >
        {t(selectText)}
      </Button>
    </div>
  </div>
)

ProtrackLevel.propTypes = {
  protrackLevel: PropTypes.oneOfType([PropTypes.instanceOf(OnboardingLevel), ImmutablePropTypes.map]).isRequired,
  selectText: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  onViewExamples: PropTypes.func.isRequired,
  subscribeToProTrack: PropTypes.func.isRequired,
  isFinished: PropTypes.bool,
  svgProps: PropTypes.object.isRequired,
}

ProtrackLevel.defaultProps = {
  svgProps: {
    width: '20',
    height: '20',
    viewBox: '0 0 15 15',
    background: '#2ED8A7',
    checkcolor: '#fff',
    circleborder: '#fff',
    style: { marginBottom: '3', marginRight: '8' },
  },
}

export default ProtrackLevel
